// extracted by mini-css-extract-plugin
module.exports = {"news":"news-module--news--1V6Nv","section__name":"news-module--section__name--3Ov_Q","news__title":"news-module--news__title--3hE8q","news__body":"news-module--news__body--9OjJT"};